<app-duke-alert
  type="warning"
  icon="fa-user-shield"
  [alertClass]="class"
>
  <form
    [formGroup]="formGroup"
    (ngSubmit)="onSubmit()"
  >
    <ng-content></ng-content>

    <ul
      class="nav nav-tabs nav-fill"
      *ngIf="hasPasskey && hasPassword"
    >
      <ng-container *ngFor="let tab of tabs">
        <li
          class="nav-item"
          *ngIf="tab === 'password'"
        >
          <a
            data-test-password-tab
            class="nav-link d-flex align-items-center flex-row"
            [ngClass]="{
                'active':  activeTab === 'password'
              }"
            tabindex="0"
            role="tab"
            placement="auto"
            [ngbTooltip]="('authorize-action.password-tab.tooltip'|translate)"
            (keyup.enter)="changeTab('password')"
            (click)="changeTab('password')"
          >
            <div class="tab-label">
              {{'authorize-action.password-tab.label'|translate}}
            </div>
          </a>
        </li>
        <li
          class="nav-item"
          *ngIf="tab === 'passkey'"
        >
          <a
            data-test-passkey-tab
            class="nav-link d-flex align-items-center flex-row"
            [ngClass]="{
                'active':  activeTab === 'passkey'
              }"
            tabindex="0"
            role="tab"
            placement="auto"
            [ngbTooltip]="('authorize-action.passkey-tab.tooltip'|translate)"
            (keyup.enter)="changeTab('passkey')"
            (click)="changeTab('passkey')"
          >
            <div class="tab-label">
              {{'authorize-action.passkey-tab.label'|translate}}
            </div>
          </a>
        </li>
      </ng-container>
    </ul>
    <div
      #tabHolder
      class="tab-content"
    >
      <div
        #passwordTab
        id="auth_password_tab"
        class="tab-pane {{activeTab === 'password' ? 'active' : ''}}"
        *ngIf="hasPassword"
      >
        <!--suppress HtmlFormInputWithoutLabel -->
        <input
          type="text"
          name="userName"
          autocomplete="username"
          hidden
          [value]="profile ? profile.email : ''"
        />
        <div
          app-form-input
          autocomplete="current-password"
          field="password"
          label="{{'authorize-action.password.label'|translate}}"
          type="password"
          [isInvalid]="formGroup.get('password').touched && (!formGroup.get('password').value?.length || error?.error === 'invalid_username_or_password')"
          [isValid]="formGroup.get('password').touched && formGroup.get('password').value?.length && !(error?.error === 'invalid_username_or_password')"
        >
          <div
            app-form-input-feedback
            type="invalid"
            *ngIf="formGroup.get('password').touched && formGroup.get('password').value?.length && !(error?.error === 'invalid_username_or_password')"
          >{{'authorize-action.password.error-message.required'|translate}}</div>
          <div
            app-form-input-feedback
            type="invalid"
            *ngIf="error?.error === 'invalid_username_or_password'"
          >{{'authorize-action.password.error-message.error-message.incorrect'|translate}}</div>
        </div>
        <div class="d-flex flex-row-reverse">
          <button
            data-test-change-login-button
            type="submit"
            class="btn btn-primary"
            [disabled]="!formGroup.get('password').value?.length"
          >{{'authorize-action.password.confirm-button.label'|translate}}</button>
          <button
            data-test-cancel-login-change-button
            type="button"
            class="btn btn-secondary mr-2"
            (click)="closeHandler()"
          >{{'authorize-action.password.cancel-button.label'|translate}}</button>
        </div>
      </div>
      <div
        #passkeyTab
        id="auth_passkey_tab"
        class="tab-pane {{activeTab === 'passkey' ? 'active' : ''}}"
        *ngIf="hasPasskey"
      >
        <div class="passkeyHolder">
        <ng-container *ngIf="!!passkeyActive">
          <h6 class="text-center">{{'authorize-action.passkey.waiting-label'|translate}}</h6>
          <div class="loader-wrapper position-relative d-block mb-2">
            <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
          </div>
        </ng-container>
        <button
          *ngIf="!passkeyActive"
          class="btn btn-primary btn-block"
          (click)="triggerPasskey()"
        >{{'authorize-action.passkey.confirm-button.label'|translate}}</button>
          <div
            app-form-input-feedback
            type="invalid"
            *ngIf="error?.error === 'invalid_credential'"
            style="transform: none;"
          >{{'authorize-action.passkey.error-message.incorrect'|translate}}</div>
        </div>
        <div class="d-flex flex-row-reverse">
          <button
            data-test-cancel-login-change-button
            type="button"
            class="btn btn-secondary"
            (click)="closeHandler()"
          >{{'authorize-action.passkey.cancel-button.label'|translate}}</button>
        </div>
      </div>
    </div>
  </form>
</app-duke-alert>
